import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OWNER_EMAIL = "gamelensphotos@gmail.com";

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// One silent retry through the refresh endpoint when the 15-min access token expires.
let refreshing = null;
axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retried &&
      !String(original.url || "").includes("/auth/")
    ) {
      original._retried = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => {
            refreshing = null;
          });
        await refreshing;
        return axios(original);
      } catch {
        /* fall through to the original error */
      }
    }
    return Promise.reject(error);
  }
);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const signInWithGoogle = (returnTo = "/inbox") => {
  sessionStorage.setItem("gl_return", returnTo);
  const redirectUrl = window.location.origin + "/inbox";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const checkOwner = async () => {
  try {
    const { data } = await axios.get(`${API}/auth/owner-check`, { withCredentials: true });
    return data.owner ? data.user : null;
  } catch {
    return null;
  }
};

// Signed-in customer (or any user) — null when anonymous.
export const getMe = async () => {
  try {
    const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
    return data;
  } catch {
    return null;
  }
};

export const signInWithPassword = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
  return data;
};

export const forgotPassword = async (email) => {
  const { data } = await axios.post(`${API}/auth/forgot-password`, { email }, { withCredentials: true });
  return data;
};

// "Keep me signed in until I tap Lock" — the owner PIN survives tab closes.
// Wrapped: some mobile browsers (private mode / tracking protections) throw on storage access.
export const getSavedPin = () => {
  try {
    return localStorage.getItem("gl_pin") || "";
  } catch {
    return "";
  }
};
export const savePin = (pin) => {
  try {
    localStorage.setItem("gl_pin", pin);
  } catch {
    /* storage unavailable — sign-in just won't persist */
  }
};
export const clearPin = () => {
  try {
    localStorage.removeItem("gl_pin");
  } catch {
    /* ignore */
  }
};
